import { render, staticRenderFns } from "./Family-statement-notification-search.vue?vue&type=template&id=02b9c59e&scoped=true"
import script from "./Family-statement-notification-search.vue?vue&type=script&lang=js"
export * from "./Family-statement-notification-search.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-notification-search.vue?vue&type=style&index=0&id=02b9c59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b9c59e",
  null
  
)

export default component.exports